export async function download(downloadUrl: string, name: string = '') {
	// initiate download
	const file = await fetch(downloadUrl);
	const blob = await file.blob();
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.style.display = 'none';
	a.href = url;
	// the filename you want
	if (name) {
		a.download = name;
	} else {
		const b = document.createElement('a');
		b.href = downloadUrl;
		a.download = b.pathname.split('/').pop()!;
	}
	document.body.appendChild(a);
	a.click();
}
